import React from 'react';
import select_box from './select-box.svg';
import select_box_blank from './select-box-blank.svg';
import styled from 'styled-components';
type Props = {
  value?: boolean;
  onChange?: (value: boolean) => void;
};
const Checkbox = ({ value, onChange }: Props) => {
  return (
    <Container type='button' onClick={() => onChange?.(!value)}>
      <img className='select_box' src={value ? select_box : select_box_blank} alt="select_box_blank" />
    </Container>
  );
};

export default Checkbox;
const Container = styled.button`
  display: flex;
  align-items: center;
  .select_box {
    width: 32px;
    height: 32px;
    aspect-ratio: 1/1;
  }
`;